module.exports = "/_next/static/images/1d74beae8f228430daa5a53385413ef9-open-graph-experiment-large.jpg.webp";